// src/offline/deletePrefix.ts
import type { Table } from "dexie";
import { db } from "../db";
import { removeDownloadedPrefix } from "./offlineMeta";

const DELETE_CHUNK = 50000;

async function deleteByPrefix(table: Table<any, any>, prefix: string, label: string) {
  const batch: any[] = [];
  const collection = table.where("prefix").equals(prefix);
  const t0 = performance.now();
  let keysCount = 0;

  await collection.eachPrimaryKey(async (key) => {
    batch.push(key);
    keysCount++;
    if (batch.length >= DELETE_CHUNK) {
      await table.bulkDelete(batch.splice(0, batch.length));
    }
  });

  if (batch.length) {
    await table.bulkDelete(batch);
  }

  const t1 = performance.now();
  console.info(
    `[offline delete] ${label} prefix=${prefix} removed ${keysCount} rows in ${(t1 - t0).toFixed(0)}ms`
  );
}

export async function deleteOfflinePrefix(prefix: string) {
  await db.transaction(
    "rw",
    [db.addresses, db.addressStates, db.customers, db.notesSynced],
    async () => {
      await deleteByPrefix(db.addresses, prefix, "addresses");
      await deleteByPrefix(db.addressStates, prefix, "addressStates");
      await deleteByPrefix(db.customers, prefix, "customers");
      await deleteByPrefix(db.notesSynced, prefix, "notesSynced");
    }
  );

  await removeDownloadedPrefix(prefix);
}
